import {
  WriteReviewTipsPropsActions,
  WriteReviewTipsPropsMicrocopy,
} from '../../molecules/WriteReviewTips';

export const MAX_TITLE_CHARS = 60;

export type WriteReviewModalPropsMicrocopy = {
  title: string;
  version: string;
  ownedDate: string;
  rateExperience: string;
  titleReview: string;
  titleReviewPlaceholder: string;
  writeReview: string;
  writeReviewPlaceholder: string;
  tips: WriteReviewTipsPropsMicrocopy;
  cancel: string;
  submit: string;
  close: string;
  remaining: string;
  remainingTitle: string;
  ratingValidationMessage: string;
  titleValidationMessage: string;
  reviewValidationMessage: string;
};

export type WriteReviewModalPropsData = {
  title: string;
  imageUrl: string;
  version: string;
  ownedDate: string;
  data?: ReviewFormData;
};

export type WriteReviewModalPropsWithMicrocopy = WriteReviewModalPropsData & {
  microcopy: WriteReviewModalPropsMicrocopy;
};

export type ReviewFormData = {
  rating: number;
  title: string;
  review: string;
};

export type WriteReviewModalPropsActions = WriteReviewTipsPropsActions & {
  onSubmit: (data: ReviewFormData) => void;
};

export type WriteReviewModalProps = WriteReviewModalPropsWithMicrocopy &
  WriteReviewModalPropsActions & {
    className?: string;
  };
